import { Controller, Control, RegisterOptions, FieldValues, Path, FieldErrors } from 'react-hook-form'
import { TextField, TextFieldProps } from '@mui/material'

type InputWithValidationProps<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
  errors: FieldErrors<T>
  rules?: RegisterOptions<T, Path<T>>
  defaultValue?: string
  sx?: TextFieldProps['sx']
} & Omit<TextFieldProps, 'name' | 'error' | 'helperText' | 'sx'>

const InputWithValidation = <T extends FieldValues>({
  name,
  control,
  errors,
  rules,
  defaultValue = '',
  sx,
  ...textFieldProps
}: InputWithValidationProps<T>) => {
  const fieldError = name.split('.').reduce<any>((acc, key) => acc?.[key], errors)

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as any}
      rules={rules as any}
      render={({ field }) => (
        <TextField
          {...field}
          {...textFieldProps}
          fullWidth
          variant="outlined"
          size="small"
          error={!!fieldError}
          helperText={fieldError?.message as string}
          InputLabelProps={{ ...textFieldProps.InputLabelProps }}
          sx={sx}
        />
      )}
    />
  )
}

export default InputWithValidation
